import React from 'react'

import { FadeIn } from '@pb/components'

import styles from './ClubCardLoader.scss'

const ClubCardLoader: React.FC = () => <FadeIn className={styles.container} />

export default ClubCardLoader
